<template>
  <div class="products">
    <h1>Modifica Prodotto</h1>
      <div class="form">
        <div>
          <input type="text" name="name" placeholder="NOME" v-model="name">
        </div>
        <div>
          <input type="text" name="ean" placeholder="EAN" v-model="ean">
        </div>
        <div>
          <input type="text" name="sku" placeholder="FID" v-model="sku">
        </div>
        <div>
          <input type="text" name="brand" placeholder="BRAND" v-model="brand">
        </div>
        <div>
          <input type="text" name="category" placeholder="CATEGORIA" v-model="category">
        </div>
        <div>
          <input type="number" name="bprice" placeholder="PREZZO ACQUISTO" v-model="bprice">
        </div>
        <div>
          <input type="number" name="price" placeholder="PREZZO SOGLIA" v-model="price">
        </div>

        <div>
          <button class="app_btn" @click="updateProduct">Salva</button>
        </div>

        <div v-for="website in websitesmap" v-bind:key="website" v-if="website.value">
          <div>
              <a :href="website.baseurl" target="_blank">{{ website.name }}</a><!-- - {{website._id}}-->
              <span v-if="website.value"> -
                <a :href="website.value" target="_blank">VEDI SCHEDA ARTICOLO</a>
              </span>
              - <a href="#" @click="cleanHistory(website._id)">RIMUOVI STORICO PREZZI</a>
          </div>
          <input :name="website._id + '-input'" type="text" placeholder="" v-model="website.value">
        </div>

        <div>
          <button class="app_btn" @click="updateProduct">Salva</button>
        </div>

        <div v-for="website in websitesmap" v-bind:key="website" v-if="!website.value">
          <div>
              <a :href="website.baseurl" target="_blank">{{ website.name }}</a><!-- - {{website._id}}-->
              <span v-if="website.value"> -
                <a :href="website.value" target="_blank">VEDI SCHEDA ARTICOLO</a>
              </span>
              - <a href="#" @click="cleanHistory(website._id)">RIMUOVI STORICO PREZZI</a>
          </div>
          <input :name="website._id + '-input'" type="text" placeholder="" v-model="website.value">
        </div>

        <div>
          <button class="app_btn" @click="updateProduct">Salva</button>
        </div>
      </div>
  </div>
</template>

<script>
import ProductsService from '@/services/ProductsService'
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'EditProduct',
  data () {
    return {
        name: '',
        ean: '',
        sku: '',
        brand: '',
        category: '',
        bprice: 0,
        price: 0,
        websites: {},
        websitesmap: []
    }
  },
  async mounted () {
      await this.getWebsites()
      await this.getProduct()
  },
  methods: {
    async getProduct () {
      const response = await ProductsService.get({
        id: this.$route.params.id
      })
      this.name = response.data.name
      this.ean = response.data.ean
      this.sku = response.data.sku
      this.brand = response.data.brand
      this.category = response.data.category
      this.bprice = response.data.bprice
      this.price = response.data.price
      this.websites = response.data.websites
      for (var website in this.websitesmap) {
          var id = this.websitesmap[website]._id
          this.websitesmap[website].value = this.websites[id]
      }
    },
    async getWebsites () {
      const response = await WebsitesService.fetch()
      this.websitesmap = response.data.websites
      // console.log(response)
      // console.log(this.websitesmap)
    },
    async updateProduct () {
      let product = {
        id: this.$route.params.id,
        name: this.name,
        ean: this.ean,
        sku: this.sku,
        brand: this.brand,
        category: this.category,
        bprice: this.bprice,
        price: this.price,
        websites: {}
      }
      for (var website in this.websitesmap) {
        // console.log(website._id)
        // console.log(this.websites[website._id])
        var id = this.websitesmap[website]._id
        if (!product.websites[id]) {
          product.websites[id] = ''
        }
        product.websites[id] = this.websitesmap[website].value
      }
      await ProductsService.update(product)
      this.$router.push({ name: 'Products' })
    },
    async cleanHistory (websiteId) {
        if (confirm('Stai cancellando tutto lo storico per questo prodotto, sei sicuro?')) {
            await ProductsService.cleanhistory(websiteId, this.$route.params.id)
            alert('eliminata')
        }
    }
  }
}
</script>
<style type="text/css">
.form input, .form textarea {
  width: 100%;
  max-width: 500px;
  padding: 10px;
  border: 1px solid #e0dede;
  outline: none;
  font-size: 12px;
}
.form div {
  margin: 20px;
}
.app_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditProduct.vue